import XLSX from 'xlsx';

export const exportExcel = {
  getCellWidth(value) {
    // 判断是否为null或undefined
    if (value == null) {
      return 10;
    } else if (/.*[\u4e00-\u9fa5]+.*$/.test(value)) {
      // 判断是否包含中文
      return value.toString().length * 2.1;
    } else {
      return value.toString().length * 1.1;
    }
  },

  /**
   * 将table、json数据导出为excel
   * @param {object} options
   * @param {[]} options.data 数据源
   * @param {"table"|"json"|"aoe"} options.dataType 数据类型
   * @param {string} options.sheetName sheet名称
   * @param {boolean} options.saveFile 是否保存为文件，如果为false则返回workBook
   * @param {string} options.fileName 文件名称
   * @param {boolean} options.fitWidth是否自适应列宽(如果dataType="json",配置此属性将无效)
   * @param {[]} options.header xlsx内部参数
   * @param {boolean} options.changeTitle 是否修改第一行标题内容
   */
  exportTo({
    data = [],
    dataType = 'table',
    sheetName = 'Sheet1',
    saveFile = true,
    fileName = new Date().$toString() + '.xlsx',
    fitWidth = true,
    header = [],
    changeTitle = false,
  } = {}) {
    try {
      if (!XLSX) throw 'exportTo: the plug-in "XLSX" is undefined.';
      if (!data || data.length === 0) throw 'exportTo: data is null or undefined.';

      let sheet = {};
      switch (dataType) {
        case 'table':
          //懒得写了，下次再改
          sheet = XLSX.utils.table_to_sheet(data, { raw: true, header: header });
          console.log(sheet);
          //   for (var p in sheet) {
          //     if (sheet[p].hasOwnProperty('v') && sheet[p].v != '0') {
          //       console.log(sheet[p].v + '=========', this.getCellWidth(sheet[p].v));
          //     }
          //   }
          // 当设置changeTitle不为默认值时，则修改第一行标题内容
          if (changeTitle) {
            var list = fileName.split('.');
            list.pop();
            sheet['A1']['v'] = list.join();
          }
          sheet['!cols'].push({ wch: '22' });
          sheet['!cols'].push({ wch: '25.2' });
          break;
        case 'json':
          sheet = XLSX.utils.json_to_sheet(data, { raw: true, header: header });
          if (fitWidth) {
            let colWidths = [],
              colNames = Object.keys(data[0]); // 所有列的名称数组

            // 计算每一列的所有单元格宽度
            // 先遍历行
            data.forEach((row) => {
              // 列序号
              let index = 0;
              // 遍历列
              for (const key in row) {
                if (colWidths[index] == null) colWidths[index] = [];

                switch (typeof row[key]) {
                  case 'string':
                  case 'number':
                  case 'boolean':
                    colWidths[index].push(getCellWidth(row[key]));
                    break;
                  case 'object':
                  case 'function':
                    colWidths[index].push(0);
                    break;
                }
                index++;
              }
            });
            sheet['!cols'] = [];
            // 每一列取最大值最为列宽
            colWidths.forEach((widths, index) => {
              // 计算列头的宽度
              widths.push(getCellWidth(colNames[index]));
              // 设置最大值为列宽
              sheet['!cols'].push({ wch: Math.max(...widths) });
            });
          }
          break;
        case 'aoe':
          // 未实现
          sheet = [];
          break;
      }

      let workBook = {
        SheetNames: [sheetName],
        Sheets: {
          [sheetName]: sheet,
        },
      };

      if (saveFile) {
        XLSX.writeFile(workBook, fileName);
        return true;
      } else {
        return workBook;
      }
    } catch (error) {
      console.error('exportTo: ', error);
      throw error;
    }
  },
};
